import React from "react";
import SkeletonCard from "./SkeletonCard";

const StatsCard = ({
  title,
  headers,
  data,
  leftDropdownComponent,
  rightDropdownComponent,
  isLoading,
}) => {
  return (
    <div
      className="bg-white border rounded shadow-sm p-2"
      style={{ height: "420px", overflowY: "auto" }}
    >
      {isLoading ? (
        <>
          <SkeletonCard count={10} height={20} />
        </>
      ) : (
        <>
          {/* Actual title and dropdowns */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center gap-2">
              <h6 className="mt-1 p-1">{title}</h6>
              {leftDropdownComponent && (
                <div style={{ minWidth: "100px" }}>{leftDropdownComponent}</div>
              )}
            </div>
            {rightDropdownComponent && (
              <div style={{ minWidth: "100px" }}>{rightDropdownComponent}</div>
            )}
          </div>

          {/* Table */}
          <table className="table table-sm mb-0">
            <thead>
              <tr>
                {headers.map((header, i) => (
                  <th
                    key={i}
                    className="text-uppercase "
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      background: "white",
                      fontSize: "0.55rem",
                      fontWeight: "400",
                      paddingLeft: "2px",
                      paddingRight: "2px",
                    }}
                  >
                    {header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.map((row, i) => (
                <tr key={i} style={{ borderBottom: "2px solid #FF641B" }}>
                  {row.map((cell, j) => (
                    <td key={j} style={{ fontSize: "0.75rem" }}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default StatsCard;
